import { useEffect, useRef, useState } from "react";
import { StageEditorLoader } from "./StageEditorLoader.js";
import { StageMakerHub } from "./StageMakerHub.js";
import { StageMakerGate } from "./StageMakerGate.js";
import { TryCustomRun } from "./TryCustomRun.js";
import { parseStageMakerPath } from "./stageMakerPath.js";
import { createDraft } from "./stageRecord.js";
import { saveStage } from "./customStagesClient.js";
import "../../../mocks/css/stage-editor.css";
import "./stage-maker.css";

export function StageMakerApp() {
  return <StageMakerGate><StageMakerRoutes /></StageMakerGate>;
}

function StageMakerRoutes() {
  const view = parseStageMakerPath(window.location.pathname);
  if (view.kind === "new") return <CreateStage />;
  if (view.kind === "play") return <TryCustomRun id={view.id} />;
  if (view.kind === "edit") return <StageEditorLoader id={view.id} />;
  return (
    <div className="stage maker-page">
      <div className="device">
        <StageMakerHub />
      </div>
    </div>
  );
}

function CreateStage() {
  const started = useRef(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    const draft = createDraft(Date.now());
    void saveStage(draft, localStorage)
      .then(() => window.location.replace(`/stage-maker/${draft.id}`))
      .catch((cause: unknown) => setError(cause instanceof Error ? cause.message : "作成に失敗しました"));
  }, []);
  return error
    ? <main className="maker-hub"><p role="alert">{error}</p><a href="/stage-maker">一覧へ</a></main>
    : <p className="maker-hub">作成中</p>;
}
